var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.birthday(_vm.billingDate))?_c('div',{staticClass:"pt-1"},[_c('v-chip',{attrs:{"color":_vm.chipColor}},[_vm._v(" Payment "+_vm._s(_vm.billingText)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }